import Vue from 'vue';
import i18n from "vue-i18n"
import router from "@/router";

export default {
  state: {
    tooltips: {
      tooltips: [],
      tooltip: {
        titulo: '',
        contenido: '',
        origen: '',
        suborigen: '',
        status: 1
      }
    }
  },
  mutations: {
    setTooltips(state, tooltips) {
      state.tooltips.tooltips = tooltips;
    },
    setTooltip_De_La_Seccion(state, tooltip) {
      state.tooltips.tooltip = tooltip;
    },
  },
  actions: {
    Consultar_Tooltips(context) {
      $.getJSON(Vue.http.options.url_admin + "/tooltips", function (data, status) {
        context.commit('setTooltips', data);
        context.dispatch('Definir_Tooltip_De_La_Seccion');
      });
    },
    Definir_Tooltip_De_La_Seccion(context) {
      const currentRoute = router.currentRoute.path;
      let lastSection = currentRoute.split("/").filter(Boolean).pop().toLowerCase();

      if (tieneNumeros(lastSection)) {
        lastSection = currentRoute.split("/")[currentRoute.split("/").length - 2];
      }
      // console.log("DEBUG: Ruta actual:", lastSection);
      const tooltips = context.state.tooltips.tooltips;

      var titulo = '';
      var contenido = '';
      for (var i = 0; i < tooltips.length; i++) {
        const tooltip = tooltips[i];

        if (lastSection == toSnakeCase(tooltip.id_traduccion)) {
          // console.log('DEBUG: toSnakeCase(tooltip.id_traduccion)', toSnakeCase(tooltip.id_traduccion));
          // titulo = tooltip.titulo;
          switch (Vue.i18n.locale) {
            case 'es':
              titulo = tooltip.titulo;
              contenido = tooltip.contenido;
              break;
            case 'en':
              titulo = tooltip.titulo_ingles;
              contenido = tooltip.contenido_ingles;
              break;

            default:
              titulo = tooltip.titulo;
              contenido = tooltip.contenido;
              break;
          }
        }

        $(document).ready(function () {
          $('#button_help').popover('hide');
          $('#breadcrumb_help').empty().append('<a data-trigger="hover" data-container="body"  id="button_help" style="color:#a1aab2 !important;" class="btn btn-link pt-1 pl-0" data-toggle="popover" title="' + titulo + '" data-content="' + contenido + '"><i class="fas fa-question-circle"></i></a>');
          $('[data-toggle="popover"]').popover();
        });
        context.commit('setTooltip_De_La_Seccion', context.state.tooltips.tooltips[i]);


      }


    },
    // Definir_Tooltip_De_La_Seccion(context) {

    //   var nomseccion_menu = context.rootState.menu.menu.opcion.name;
    //   if (context.rootState.menu.menu.opcion.origin1.name == "") {
    //     var origen_menu = context.rootState.menu.menu.opcion.name;
    //   } else {
    //     var origen_menu = context.rootState.menu.menu.opcion.origin1.name;
    //   }

    //   var suborigen_menu = context.rootState.menu.menu.opcion.origin2.name;
    //   var encontre = false;
    //   var titulo = '';
    //   var contenido = '';

    //   for (var i = 0; i < context.state.tooltips.tooltips.length; i++) {
    //     var nomseccion_tooltip = context.state.tooltips.tooltips[i].nomseccion;
    //     var origen_tooltip = context.state.tooltips.tooltips[i].origen;
    //     var suborigen_tooltip = context.state.tooltips.tooltips[i].suborigen;

    //     const nomSeccionTootltip = Vue.i18n.t(`ayuda_tooltips.${toSnakeCase(nomseccion_tooltip)}`);
    //     let nomSeccionMenu = Vue.i18n.t(`ayuda_tooltips.${toSnakeCase(nomseccion_menu)}`);

    //     // console.log('DEBUG: nomSeccionTootltipANTES', nomSeccionTootltip, nomSeccionMenu);

    //     if (nomSeccionMenu.includes('ayuda_tooltips')) {
    //       nomSeccionMenu = nomSeccionTootltip;
    //     } else {
    //       nomSeccionMenu = Vue.i18n.t(`ayuda_tooltips.${toSnakeCase(nomseccion_menu)}`);
    //     }
    //     // console.log('DEBUG: nomSeccionTootltip', nomSeccionTootltip, nomSeccionMenu);
    //     console.log('DEBUG: origen_tooltip', suborigen_menu, suborigen_tooltip);

    //     if (origen_tooltip == origen_menu
    //       && suborigen_menu == suborigen_tooltip
    //       && nomSeccionMenu == nomSeccionTootltip
    //     ) {

    //       encontre = true;

    //       context.commit('setTooltip_De_La_Seccion', context.state.tooltips.tooltips[i]);

    //       switch (Vue.i18n.locale) {
    //         case 'es':
    //           titulo = context.state.tooltips.tooltips[i].titulo;
    //           contenido = context.state.tooltips.tooltips[i].contenido;
    //           break;
    //         case 'en':
    //           titulo = context.state.tooltips.tooltips[i].titulo_ingles;
    //           contenido = context.state.tooltips.tooltips[i].contenido_ingles;
    //           break;

    //         default:
    //           titulo = context.state.tooltips.tooltips[i].titulo;
    //           contenido = context.state.tooltips.tooltips[i].contenido;
    //           break;
    //       }
    //       // titulo = context.state.tooltips.tooltips[i].titulo;
    //       // contenido = context.state.tooltips.tooltips[i].contenido;
    //     }
    //   }

    //   console.log('DEBUG: encontre', encontre);

    //   if (encontre) {
    //     $(document).ready(function () {
    //       $('#button_help').popover('hide');
    //       $('#breadcrumb_help').empty().append('<a data-trigger="hover" data-container="body"  id="button_help" style="color:#a1aab2 !important;" class="btn btn-link pt-1 pl-0" data-toggle="popover" title="' + titulo + '" data-content="' + contenido + '"><i class="fas fa-question-circle"></i></a>');
    //       $('[data-toggle="popover"]').popover();
    //     });
    //   } else {
    //     $(document).ready(function () {
    //       $('#button_help').popover('hide');
    //       $('#breadcrumb_help').empty();
    //     });
    //   }
    // },
  },
  getters: {
    getTooltips(state) {
      return state.tooltips.tooltips;
    },
    getTooltip(state) {
      return state.tooltips.tooltip;
    },
  },

}

function toSnakeCase(str) {
  return str
    .normalize("NFD") // Descompone caracteres con acentos en su forma base
    .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
    .toLowerCase() // Convierte a minúsculas
    .replace(/\s+/g, "_") // Reemplaza espacios por guiones bajos
    .replace(/[^\w_]/g, ""); // Elimina caracteres no alfanuméricos excepto _
}

function tieneNumeros(string) {
  const regex = /\d/; // Expresión regular para buscar al menos un dígito
  return regex.test(string);
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/tooltips.js